<template>
    <div class="reservation">
        <el-card class="reservation-form reservation-content">
            <template slot="header">
                <h3>预约信息</h3>
            </template>
            <el-form :model="formData" size="medium" :rules="rules" ref="formRef" label-width="100px"
                label-position="top" class="reservation-form-container">
                <!-- 预约日期 -->
                <el-form-item label="预约日期" prop="reserveDate">
                    <div class="date-picker">
                        <div class="date-buttons">
                            <div v-for="item in dateList" :key="item.date" class="date-item" :class="{
                                'is-active': formData.reserveDate === item.saleDate,
                                'is-disabled': item.isSale == 0
                            }" @click="handleDateSelect(item)">
                                <div class="date-text">{{ item.saleDate | filterTime('MM-DD') }}</div>
                                <div class="remaining-text">余{{ item.remainingQuantity }}</div>
                            </div>
                            <div class="date-item" @click="handleDateSelectMore">
                                <i class="el-icon-date" style="font-size: 32px;"></i>
                            </div>
                        </div>
                        <div class="date-range-tip">{{ getDateText() }}</div>
                    </div>
                </el-form-item>

                <el-row :gutter="20">
                    <el-col :span="12">
                        <!-- 联系人 -->
                        <el-form-item label="联系人" prop="contactPerson">
                            <el-input v-model="formData.contactPerson" placeholder="请输入联系人姓名" :maxlength="10" />
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <!-- 联系电话 -->
                        <el-form-item label="联系电话" prop="contactPhone">
                            <el-input v-model="formData.contactPhone" placeholder="接收行程短信的手机号码" :maxlength="11" />
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="12">
                        <!-- 行程人数 -->
                        <el-form-item label="行程人数" prop="passengerNum">
                            <el-radio-group v-model="formData.passengerNum">
                                <el-radio-button v-for="item in peopleNum" :key="item" :label="item">{{ item
                                }}</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="20">
                    <el-col :span="12">
                        <!-- 接送拼车 -->
                        <el-form-item label="拼车/包车" prop="poolType">
                            <el-radio-group v-model="formData.poolType">
                                <el-radio-button
                                    v-if="goodsDetail.serviceModeType == 3 || goodsDetail.serviceModeType == 2"
                                    :label="2">拼车</el-radio-button>
                                <el-radio-button
                                    v-if="goodsDetail.serviceModeType == 3 || goodsDetail.serviceModeType == 1"
                                    :label="1">包车</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="单程/往返" prop="lineType">
                            <el-radio-group v-model="formData.lineType">
                                <el-radio-button :label="1"
                                    v-if="goodsDetail.goLineList?.length > 0">去程</el-radio-button>
                                <el-radio-button :label="2"
                                    v-if="goodsDetail.returnLineList?.length > 0">返程</el-radio-button>
                                <el-radio-button :label="3"
                                    v-if="goodsDetail.goLineList?.length > 0 && goodsDetail.returnLineList?.length > 0">往返</el-radio-button>
                            </el-radio-group>
                        </el-form-item>
                    </el-col>
                </el-row>

                <!-- 备注信息 -->
                <el-form-item label="备注信息" prop="remark">
                    <el-input type="textarea" v-model="formData.remark" :rows="4" :maxlength="100" show-word-limit
                        placeholder="请输入100字以内的备注" />
                    <div class="quick-tags">
                        <el-tag v-for="tag in quickTags" :key="tag" @click="addQuickTag(tag)" type="info" effect="plain"
                            style="margin-right: 10px; cursor: pointer">
                            {{ tag }}
                        </el-tag>
                    </div>
                </el-form-item>
            </el-form>
            <!-- 日历弹窗 -->
            <el-dialog :visible.sync="calendarVisible" width="700px" custom-class="calendar-dialog"
                :destroy-on-close="true" :close-on-click-modal="false">
                <div class="calendar-header">
                    <div class="month-switcher">
                        <i class="el-icon-arrow-left" @click="changeMonth(-1)"></i>
                        <span>{{ currentYear }}年{{ currentMonth }}月</span>
                        <i class="el-icon-arrow-right" @click="changeMonth(1)"></i>
                    </div>
                </div>
                <div class="calendar-body">
                    <div class="week-header">
                        <div v-for="week in ['周一', '周二', '周三', '周四', '周五', '周六', '周日']" :key="week">
                            {{ week }}
                        </div>
                    </div>
                    <div class="days-grid">
                        <div v-for="(day, index) in calendarDays" :key="index" class="day-cell" :class="{
                            'is-selected': isSelectedDay(day),
                            'is-disabled': day.disabled,
                            'other-month': !day.currentMonth
                        }" @click="selectDate(day)">
                            <span class="day-number">{{ day.date }}</span>
                            <span class="remaining" v-if="day.currentMonth">余: {{ day.remaining }}</span>
                        </div>
                    </div>
                </div>
            </el-dialog>
        </el-card>

        <el-card class="reservation-form">
            <!-- 操作按钮 -->
            <div class="form-actions">
                <div>支付金额：<span class="util-money" style="font-size: 20px;">{{ payAmount }}</span>元</div>
                <div>
                    <el-button size="medium" @click="handleCancel">取消</el-button>
                    <el-button size="medium" type="primary" @click="handleSubmit">确定</el-button>
                </div>
            </div>
        </el-card>
    </div>
</template>

<script>
export default {
    name: 'ReservationForm',
    data() {
        return {
            goodsDetail: {},
            goodsId: this.$route.query.goodsId,
            peopleNum: Number(this.$route.query.peopleNum),
            reservationTime: Number(this.$route.query.reservationTime),
            advanceReservationTime: Number(this.$route.query.advanceReservationTime),
            formData: {
                reserveDate: '',
                contactPerson: '',
                contactPhone: '',
                passengerNum: 1,
                poolType: 1,
                lineType: 1,
                remark: ''
            },
            quickTags: ['有老人', '有小孩', '有大件行李'],
            dateList: [],
            rules: {
                reserveDate: [{ required: true, message: '请选择预约日期', trigger: 'change' }],
                contactPerson: [{ required: true, message: '请输入联系人姓名', trigger: ['blur', 'change'] }],
                contactPhone: [
                    { required: true, message: '请输入联系电话', trigger: ['blur', 'change'] },
                    { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: ['blur'] }
                ],

                passengerNum: [{ required: true, message: '请选择行程人数', trigger: 'change' }],
                poolType: [{ required: true, message: '请选择拼车/包车', trigger: 'change' }],
                lineType: [{ required: true, message: '请选择单程/往返', trigger: 'change' }]
            },
            calendarVisible: false,
            currentYear: new Date().getFullYear(),
            currentMonth: new Date().getMonth() + 1,
            selectedDate: null,
            calendarDays: []
        }
    },
    computed: {
        payAmount() {
            let price = 0;
            if (this.formData.poolType == 1) {
                price = this.formData.lineType == 1 || this.formData.lineType == 2 ? this.goodsDetail.singleCharterPrice : this.goodsDetail.roundCharterPrice
            } else {
                price = this.formData.lineType == 1 || this.formData.lineType == 2 ? this.goodsDetail.singlePrice : this.goodsDetail.roundPrice
            }
            return price
        }
    },
    methods: {
        async getGoodsDetail() {
            let url = `/api/v1/manage/travelGoods/${this.goodsId}`
            let { code, data } = await this.$axios.get(url);
            if (code === 1) {
                this.goodsDetail = data;
                this.formData.poolType = data.serviceModeType == 3 ? 2 : data.serviceModeType;
                if (data.goLineList?.length > 0 && data.returnLineList?.length > 0) {
                    this.formData.lineType = 3;
                } else if (data.goLineList?.length > 0) {
                    this.formData.lineType = 1;
                } else if (data.returnLineList?.length > 0) {
                    this.formData.lineType = 2;
                } else {
                    this.formData.lineType = 1;
                }
            }

        },
        // 添加快捷标签
        addQuickTag(tag) {
            if (!this.formData.remark) {
                this.formData.remark = tag
                return
            }

            const existingTags = this.formData.remark.split('，')
            if (existingTags.includes(tag)) {
                return
            }

            this.formData.remark += '，' + tag
        },
        // 取消
        handleCancel() {
            this.$router.go(-1)
        },
        // 提交表单
        async handleSubmit() {
            if (this.dateList.every(item => item.isSale == 0)) {
                this.formData.reserveDate = null;
                this.formData.goodsInventoryId = null;
            }
            this.$refs.formRef.validate(async (valid) => {
                if (valid) {
                    console.log(this.formData)
                    let url = '/api/v1/manage/travelOrder/reservation'
                    let params = {
                        goodsId: this.goodsId,
                        goodsInventoryId: this.formData.goodsInventoryId,
                        contactPerson: this.formData.contactPerson,
                        contactPhone: this.formData.contactPhone,
                        passengerNum: this.formData.passengerNum,
                        poolType: this.formData.poolType,
                        remark: this.formData.remark,
                        lineType: this.formData.lineType,
                        price: this.payAmount
                    }
                    let { code } = await this.$axios.post(url, params)
                    if (code == 1) {
                        this.$message.success('预约成功')
                        this.$router.go(-1)
                    }
                }

            })
        },
        // 选择日期
        handleDateSelect(item) {
            if (item.isSale == 0) {
                return
            }
            this.formData.reserveDate = item.saleDate
            this.formData.goodsInventoryId = item.id
        },
        // 选择更多日期
        handleDateSelectMore() {
            if (!this.goodsId) {
                this.$message.warning('请先选择商品');
                return;
            }
            this.calendarVisible = true
            if (this.formData.reserveDate) {
                this.currentMonth = Number(this.$utils.timeFn(this.formData.reserveDate, 'MM'));
                this.currentYear = Number(this.$utils.timeFn(this.formData.reserveDate, 'YYYY'));
                this.selectedDate = {
                    date: this.$utils.timeFn(this.formData.reserveDate, 'DD'),
                };
            }
            this.initCalendar()
        },
        // 初始化日历
        async initCalendar() {
            const firstDay = new Date(this.currentYear, this.currentMonth - 1, 1)
            const lastDay = new Date(this.currentYear, this.currentMonth, 0)

            // 获取当月所有日期
            const days = []
            const firstDayWeek = firstDay.getDay() || 7 // 转换周日为7

            // 添加上月剩余日期
            for (let i = firstDayWeek - 1; i > 0; i--) {
                const date = new Date(firstDay)
                date.setDate(date.getDate() - i)
                days.push({
                    date: '',
                    currentMonth: false,
                    disabled: true,
                    remaining: 0
                })
            }

            let url = "/api/v1/manage/travelOrder/goods/inventory";
            let params = {
                goodsId: this.goodsId,
                startTime: firstDay.setHours(0, 0, 0, 0) / 1000,
                endTime: lastDay.setHours(0, 0, 0, 0) / 1000
            }
            let { code, data } = await this.$axios.get(url, params);
            if (code == 1) {
                data.forEach(item => {
                    days.push({
                        date: this.$utils.timeFn(item.saleDate, 'DD'),
                        disabled: item.isSale == 1 ? false : true,
                        currentMonth: true,
                        remaining: item.remainingQuantity,
                        id: item.id,
                        actived: this.$utils.timeFn(item.saleDate, 'MM-DD') == this.$utils.timeFn(this.formData.reserveDate, 'MM-DD')
                    });
                });
            }
            this.calendarDays = days
        },
        // 日历月份切换
        changeMonth(delta) {
            let newMonth = this.currentMonth + delta
            let newYear = this.currentYear

            if (newMonth > 12) {
                newMonth = 1
                newYear++
            } else if (newMonth < 1) {
                newMonth = 12
                newYear--
            }

            this.currentMonth = newMonth
            this.currentYear = newYear
            this.initCalendar()
        },
        isSelectedDay(day) {
            console.log(day)
            if (!this.selectedDate || !day.currentMonth) return false
            return day.actived
        },
        // 日历选择日期
        selectDate(day) {
            if (day.disabled || !day.currentMonth) {
                return
            }
            this.selectedDate = day
            let date = new Date(this.currentYear, this.currentMonth - 1, day.date).setHours(0, 0, 0, 0) / 1000;
            // 如果不在dateList中，则获取dateList
            if (!this.dateList.find(item => item.saleDate == date)) {
                this.getDateList(date);
            } else {
                this.formData.reserveDate = date;
                this.formData.goodsInventoryId = this.dateList.find(item => item.saleDate == date).id;
            }
            // 关闭日历
            this.calendarVisible = false;
        },
        // 获取日期列表
        async getDateList(startTime) {
            let startDate, endDate;
            if (startTime) {
                startDate = startTime;
                endDate = startTime + 6 * 24 * 60 * 60;
            }
            let url = "/api/v1/manage/travelOrder/goods/inventory";
            let params = {
                goodsId: this.goodsId,
                startTime: startDate,
                endTime: endDate
            }
            let { code, data } = await this.$axios.get(url, params);
            if (code == 1) {
                this.dateList = data;
                let index = data.findIndex(item => item.isSale > 0)
                if (index != -1) {
                    this.formData.reserveDate = data[index].saleDate;
                    this.formData.goodsInventoryId = data[index].id;
                }

            }
        },
        // 获取可预约日期范围文本
        getDateText() {
            const now = new Date();

            // 计算开始日期：当前日期 + 提前预约时间（天）
            const startDate = new Date(now)
            startDate.setDate(now.getDate() + this.advanceReservationTime)

            // 计算结束日期：当前日期 + 预约时间范围（天）
            const endDate = new Date(now)
            endDate.setDate(now.getDate() + this.reservationTime)

            // 格式化日期为"MM月dd日"格式
            const startText = `${String(startDate.getMonth() + 1).padStart(2, '0')}月${String(startDate.getDate()).padStart(2, '0')}日`
            const endText = `${String(endDate.getMonth() + 1).padStart(2, '0')}月${String(endDate.getDate()).padStart(2, '0')}日`

            // 返回格式化的文本
            return `可预约${startText}～${endText}内的日期`
        }
    },
    created() {
        this.formData.passengerNum = Number(this.$route.query.peopleNum);
        this.getDateList();
        this.getGoodsDetail();
    }
}
</script>

<style lang="less" scoped>
.reservation {
    display: flex;
    flex-direction: column;
    gap: 20px;

    // 滚动条样式
    ::-webkit-scrollbar {
        width: 4px;
        height: 4px;
        background-color: transparent;
    }

    ::-webkit-scrollbar-thumb {
        border-radius: 4px;
        background-color: #dcdfe6;

        &:hover {
            background-color: #c0c4cc;
        }
    }
}

.reservation-content {
    flex: 1;
    overflow-y: auto;
}

.reservation-form {
    width: 680px;
    background: #fff;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    margin: 0 auto;

    :deep(.el-card__header) {
        padding: 16px 20px;
        border-bottom: 1px solid #ebeef5;
        
        h3 {
            margin: 0;
            font-size: 16px;
            font-weight: 600;
            color: #303133;
        }
    }

    :deep(.el-card__body) {
        padding: 20px;
    }

    .date-picker {
        .date-buttons {
            display: flex;
            gap: 12px;
            flex-wrap: wrap;
        }

        .date-item {
            flex: 1;
            min-width: 70px;
            height: 56px;
            border: 1px solid #e4e7ed;
            border-radius: 8px;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            cursor: pointer;
            transition: all 0.2s ease;
            background: #fafbfc;

            &:hover:not(.is-disabled) {
                border-color: #2B77FF;
                background: #f0f7ff;
            }

            &.is-active {
                background-color: #2B77FF;
                border-color: #2B77FF;
                color: #fff;
                
                .remaining-text {
                    color: rgba(255, 255, 255, 0.8);
                }
            }

            &.is-disabled {
                background-color: #f5f7fa;
                border-color: #e4e7ed;
                color: #c0c4cc;
                cursor: not-allowed;
            }

            .date-text {
                font-size: 14px;
                font-weight: 500;
                margin-bottom: 4px;
            }

            .remaining-text {
                width: 100%;
                font-size: 12px;
                text-align: center;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
                color: #67C23A;
            }
        }

        .date-range-tip {
            margin-top: 10px;
            font-size: 12px;
            color: #909399;
            padding: 8px 12px;
            background: #f5f7fa;
            border-radius: 6px;
        }
    }

    .quick-tags {
        margin-top: 12px;
        
        .el-tag {
            border-radius: 4px;
            
            &:hover {
                background: #f0f7ff;
                border-color: #2B77FF;
                color: #2B77FF;
            }
        }
    }

    .form-actions {
        display: flex;
        align-items: center;
        justify-content: space-between;
        
        .util-money {
            color: #F56C6C;
            font-weight: 600;
        }
        
        .el-button {
            border-radius: 6px;
            min-width: 80px;
        }
    }
}

.reservation-form-container {
    :deep(.el-form-item) {
        .el-form-item__label {
            text-align: left;
            line-height: 20px;
            padding-bottom: 8px;
            color: #606266;
            font-weight: 500;
        }

        .el-input__inner {
            border-radius: 6px;
        }

        .el-textarea__inner {
            border-radius: 6px;
        }

        // 添加radio-group的样式
        .el-radio-group {
            width: 100%;
            display: flex;

            .el-radio-button {
                flex: 1;

                .el-radio-button__inner {
                    width: 100%;
                    border-radius: 6px;
                }
                
                &.is-active .el-radio-button__inner {
                    background-color: #2B77FF;
                    border-color: #2B77FF;
                }
            }
        }
    }
}

.calendar-dialog {
    :deep(.el-dialog) {
        border-radius: 8px;
    }

    .calendar-header {
        padding: 10px 0;
        text-align: left;

        .month-switcher {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            gap: 20px;
            font-size: 18px;
            font-weight: 600;
            color: #303133;
            margin-bottom: 16px;

            i {
                cursor: pointer;
                font-size: 20px;
                padding: 4px;
                border-radius: 4px;
                transition: all 0.2s ease;

                &:hover {
                    color: #2B77FF;
                    background: #f0f7ff;
                }
            }
        }
    }

    .calendar-body {
        .week-header {
            display: grid;
            grid-template-columns: repeat(7, 1fr);
            text-align: center;
            background-color: #f5f7fa;
            padding: 12px 0;
            border-radius: 6px 6px 0 0;

            >div {
                font-size: 14px;
                font-weight: 500;
                color: #606266;
            }
        }

        .days-grid {
            display: grid;
            grid-template-columns: repeat(7, 1fr);
            gap: 1px;
            background-color: #ebeef5;
            border: 1px solid #ebeef5;
            border-radius: 0 0 6px 6px;
            overflow: hidden;

            .day-cell {
                height: 80px;
                padding: 0 10px;
                background-color: #fff;
                display: flex;
                flex-direction: column;
                align-items: flex-start;
                justify-content: center;
                cursor: pointer;
                transition: all 0.2s ease;

                &:hover:not(.is-disabled):not(.other-month) {
                    background-color: #f0f7ff;
                }

                &.other-month {
                    color: #c0c4cc;
                    background-color: #fafbfc;
                }

                &.is-selected {
                    background-color: #f0f7ff;
                    color: #2B77FF;
                    box-shadow: inset 0 0 0 2px #2B77FF;
                }

                &.is-disabled {
                    cursor: not-allowed;
                    color: #c0c4cc;
                    background-color: #f5f7fa;
                }

                .day-number {
                    font-size: 16px;
                    font-weight: 600;
                    margin-bottom: 5px;
                }

                .remaining {
                    font-size: 12px;
                    color: #67C23A;
                }
            }
        }
    }

    .calendar-footer {
        margin-top: 20px;

        .remarks {
            padding: 12px 16px;
            background-color: #f5f7fa;
            border-radius: 6px;
            margin-bottom: 20px;

            p {
                margin: 5px 0;
                font-size: 12px;
                color: #606266;
            }
        }

        .dialog-footer {
            text-align: right;
            
            .el-button {
                border-radius: 6px;
            }
        }
    }
}
</style>
